import { render, staticRenderFns } from "./SearchResultRItem.vue?vue&type=template&id=adc31926&"
import script from "./SearchResultRItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultRItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports